<template>
    <Button
        :label="getLabel"
        :class="classes"
        :disabled="disabled"
        v-bind="$attrs"
    >
        <slot name="content"></slot>
    </Button>
</template>

<script>
import Button from 'primevue/button'

export default {
    name: 'CoreTableCellButton',

    components: { Button },

    props: {
        label: {
            type: String,
            default: '',
        },

        disabled: {
            type: Boolean,
            default: false,
        },

        condensed: {
            type: Boolean,
            default: false,
        },
    },

    computed: {
        classes() {
            return {
                'core-table-cell-button': true,
                'core-table-cell-button--disabled': this.disabled,
            }
        },

        getLabel() {
            return this.$t(this.label)
        },
    },
}
</script>

<style>
.core-table-cell-button {
    height: auto;
    width: 100%;
    background: var(--color-neutral-300);
    padding: 8px 14px;
    border: 1px solid var(--color-neutral-300);
    text-align: left;

    transition: background-color 0.5s, color 0.5s, border-color 0.5s, box-shadow 0.5s;

    &.p-button {
        border-radius: 4px;
    }

    & > .p-button-label {
        color: var(--color-secondary);
        font-weight: 300;
        font-size: 1.4rem;
    }

    &.p-button:enabled:hover {
        cursor: pointer;
        background: var(--color-primary-400);
        border: 1px solid var(--color-primary-400);
    }

    &.p-button:focus {
        border: 1px solid var(--color-primary-500);
    }

    &.core-table-cell-button--disabled.p-component:disabled {
        opacity: 1;
    }

    &.core-table-cell-button--disabled {
        cursor: not-allowed;
        background: var(--color-neutral-100);

        & > .p-button-label {
            color: var(--color-neutral);
        }
    }

    &.core-table-cell-button--disabled.p-button:enabled:hover {
        cursor: not-allowed;
        background: var(--color-neutral-100);

        & > .p-button-label {
            color: var(--color-neutral);
        }
    }
    &.core-table-cell-button--disabled.p-button:focus {
        background: var(--color-neutral-100);
        outline: none;

        & > .p-button-label {
            color: var(--color-neutral);
        }
    }
}
</style>
